import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { PlatformFeatures, PlatformFeaturesService } from '../../services/platform-features.service';

@Injectable({ providedIn: 'root' })
export class PlatformFeatureGuard implements CanActivate {
  constructor(
    private platformFeaturesService: PlatformFeaturesService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const feature = route.data['platformFeature'] as keyof PlatformFeatures;
    if (this.platformFeaturesService.isEnabled(feature)) {
      return true;
    }

    void this.router.navigate(['/main/dashboard']);
    return false;
  }
}
